import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { getReviewYears } from '../helpers';

const WelcomeText: FC = () => {
  const { t } = useTranslation();

  const { year, newYear } = getReviewYears();

  return (
    <ReactMarkdown className="text-center px-24 mt-7 text-primary">
      {t('yearly_review.welcome_text', { year, newYear })}
    </ReactMarkdown>
  );
};

export default WelcomeText;
